<p>
  If you have had a relationship breakdown, your former spouse may be entitled
  to a portion of your pension. You would find this <strong> Relationship breakdown
    offset </strong> in your Annual Pension Statement:
</p>